/**
 * For wrapping around elements to get a parallax 3d effect when the mouse is hovering over:
 * https://framerbook.com/animation/example-animations/26-tracking-the-cursor/
 */

import React, { useEffect, useRef, useState } from "react";
import { motion, useMotionValue, useTransform } from "framer-motion";
import useWindowSize from "../../hooks/useWindowSize";

const WrapMouseMove = ({ children }) => {
  // Keep track of viewport width even if resized
  const { width } = useWindowSize(); // height

  // Reference wrapper element, in order to calculate its width
  const wrapperWidthRef = useRef(null);

  // Set up a variable for tracking the width of the current element
  const [elementWidth, setElementWidth] = useState(0);

  // Update element width
  useEffect(() => {
    setElementWidth(wrapperWidthRef.current.offsetWidth);
    // console.log("width = " + elementWidth);
  }, [width]);

  const x = useMotionValue(1000);
  const y = useMotionValue(100);

  const rotateX = useTransform(y, [0, 1000], [5, -50]);
  const rotateY = useTransform(x, [0, elementWidth], [-5, 5]);

  function handleMouse(event) {
    const rect = event.currentTarget.getBoundingClientRect();

    x.set(event.clientX - rect.left);
    y.set(event.clientY - rect.top);
  }

  // Reset perspective when the mouse leaves
  function handleMouseLeave(event) {
    setTimeout(() => {
      x.set(1000);
      y.set(100);
    }, "500");
  }

  return (
    <div
      aria-hidden="true"
      className="transform-gpu [backface-visibility:hidden]"
      style={{
        // width: 400,
        // height: 400,
        // display: "flex",
        // placeItems: "center",
        // placeContent: "center",
        perspective: 400,
      }}
      onMouseMove={handleMouse}
      onMouseLeave={handleMouseLeave}
      ref={wrapperWidthRef}
    >
      <motion.div
        style={{
          // width: 150,
          // height: 150,
          // borderRadius: 30,
          // backgroundColor: "#fff",
          rotateX: rotateX,
          rotateY: rotateY,
        }}
        className="transform-gpu [backface-visibility:hidden] transition-transform hover:transition-none duration-200 ease-in-out"
      >
        {children}
      </motion.div>
    </div>
  );
};

export default WrapMouseMove;
